export default __webpack_public_path__ + "static/cloud-f827ad99cc32bacd4e85edf274a85a75.png";